// libs
import React, { memo } from 'react';

interface CopyProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function CouponCopy({ width = 16, height = 16, fill = '#001325', className = '' }: CopyProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0955 11.7039C13.9482 11.7039 13.8069 11.6454 13.7027 11.5411C13.5985 11.4369 13.54 11.2955 13.54 11.1481V2.63224C13.54 2.5831 13.5205 2.53597 13.4858 2.50122C13.451 2.46648 13.4039 2.44695 13.3548 2.44695H4.82201C4.67467 2.44695 4.53337 2.38839 4.42919 2.28414C4.32501 2.1799 4.26648 2.03851 4.26648 1.89109C4.26648 1.74367 4.32501 1.60228 4.42919 1.49803C4.53337 1.39379 4.67467 1.33523 4.82201 1.33523H13.3548C13.526 1.33425 13.6957 1.36702 13.8543 1.43168C14.0128 1.49633 14.1571 1.5916 14.2788 1.71204C14.4005 1.83248 14.4974 1.97573 14.5638 2.13362C14.6302 2.29151 14.6649 2.46094 14.6659 2.63224V11.1184C14.67 11.1951 14.6582 11.2719 14.6312 11.3438C14.6042 11.4157 14.5625 11.4813 14.509 11.5363C14.4554 11.5913 14.391 11.6346 14.3198 11.6635C14.2486 11.6923 14.1723 11.7061 14.0955 11.7039Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3994 3.86255H2.07402C1.87758 3.86255 1.68918 3.94064 1.55027 4.07963C1.41137 4.21862 1.33333 4.40714 1.33333 4.6037V13.9274C1.33333 14.124 1.41137 14.3125 1.55027 14.4515C1.68918 14.5905 1.87758 14.6685 2.07402 14.6685H11.3994C11.5958 14.6685 11.7842 14.5905 11.9231 14.4515C12.062 14.3125 12.1401 14.124 12.1401 13.9274V4.6037C12.1401 4.40714 12.062 4.21862 11.9231 4.07963C11.7842 3.94064 11.5958 3.86255 11.3994 3.86255ZM11.029 4.97428V13.5494H2.45919V4.97428H11.029Z"
        fill={fill}
      />
    </svg>
  );
}

export default memo(CouponCopy);
